// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__yh6Eh","link":"style_link__2xrND","tooltipWrapper":"style_tooltipWrapper__2-gt7","text":"style_text__1MqDu"};